import { useParams } from 'react-router-dom';
import { useGetSurveyQuery } from 'store/services/feedbackGroup';
import Tabs, { TabPane } from 'style-guide/Tabs';
import FeedbackQuestionView from './FeedbackQuestionView';
import IntroductionView from './IntroductionView';

const SurveyQuestionAnswer = ({ data, chapterId, feedbackGroups, surveyState }) => {
  const { surveyId } = useParams();
  const { data: surveyData } = useGetSurveyQuery({ surveyId });
  const description = data?.description || surveyData?.description;

  return (
    <Tabs>
      <TabPane tab='Introduction' key='Introduction'>
        <IntroductionView label='Introduction' chapterId={chapterId} data={description} />
      </TabPane>
      {feedbackGroups?.map((item) => (
        <TabPane tab={item.legend} key={item.id}>
          <FeedbackQuestionView
            label={item.legend}
            chapterId={chapterId}
            currentSurvey={surveyState?.find((survey) => survey?.id === item?.id)}
            groupId={item.id}
          />
        </TabPane>
      ))}
    </Tabs>
  );
};
export default SurveyQuestionAnswer;
